<template>
  <div class="container">
    <!-- 地址管理 -->
    <div class="tabs-area">
      <eui-btn @click="handleAdd('addressForm')">新增地址</eui-btn>
      <eui-btn @click="delBatch()">批量删除</eui-btn>
    </div>

    <div class="table-out">
      <e-table-list
        ref="multipleTable"
        :table-data="tableData"
        :table-label="tableLabel"
        selection-show
        row-key="addressId"
        @handleSelectionChange="handleSelectionChange"
      >
        <template #handle="{ scope }">
          <div>
            <eui-btn type="text" @click="rowEditHandle(scope.row)"
              >查看并修改</eui-btn
            >
            <eui-btn
              color="#F0250F"
              type="text"
              @click="deleteOrderAddress(scope.row)"
            >
              删除
            </eui-btn>
          </div>
        </template>
      </e-table-list>
      <div class="pagination">
        <el-pagination
          style="margin-top: 20px"
          :pager-count="5"
          :page-sizes="[10, 20, 30]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          :current-page="currentPage"
          :page-size.sync="pageSize"
          prev-text="上一页"
          next-text="下一页"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>

    <e-dialog
      :dialog-title="dialogType == 'add' ? '新增地址' : '编辑地址'"
      :center-dialog-visible="dialogFormVisible"
      :popup-width="'800px'"
      :show-close="false"
      @updateVisible="dialogFormVisible = false"
      @submitPopupData="submitForm('addressForm')"
      @resetPopupData="dialogFormVisible = false"
    >
      <el-form ref="addressForm" :model="form" :rules="rules">
        <el-row :gutter="20">
          <el-col v-show="dialogType == 'add'" :span="24">
            <el-form-item
              :rules="
                dialogType == 'add' ? rules.checkedAddr : [{ required: false }]
              "
              label="地址类型"
              prop="checkedAddr"
              :label-width="formLabelWidth"
              class="chioce-addr"
            >
              <el-checkbox-group
                v-model="form.checkedAddr"
                @change="handleCheckedAddr"
              >
                <el-checkbox label="收货地址">收货地址</el-checkbox>
                <el-checkbox label="收发票地址">收发票地址</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="收件人"
              prop="realName"
              :label-width="formLabelWidth"
            >
              <el-input
                v-model="form.realName"
                maxlength="30"
                autocomplete="off"
                placeholder="请输入收件人姓名"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="手机号"
              prop="mobile"
              :label-width="formLabelWidth"
            >
              <el-input
                v-model="form.mobile"
                maxlength="11"
                autocomplete="off"
                placeholder="请输入收件人手机号"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              label="地址"
              :label-width="formLabelWidth"
              prop="addrAll"
            >
              <div style="display: flex; justify-content: space-between">
                <el-form-item prop="provinceAreaId">
                  <el-select
                    v-model="form.provinceAreaId"
                    :popper-class="fromMall"
                    placeholder="请选择省份"
                    @change="provinceChange"
                  >
                    <el-option
                      v-for="provinceItem in provinceArr"
                      :key="provinceItem.areaId"
                      :label="provinceItem.areaName"
                      :value="provinceItem.areaId"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="cityAreaId">
                  <el-select
                    v-model="form.cityAreaId"
                    :popper-class="fromMall"
                    placeholder="请选择城市"
                    @change="cityChange"
                  >
                    <el-option
                      v-for="cityItem in cityArr"
                      :key="cityItem.areaId"
                      :label="cityItem.areaName"
                      :value="cityItem.areaId"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="countryAreaId">
                  <el-select
                    v-model="form.countryAreaId"
                    :popper-class="fromMall"
                    placeholder="区/县/街道"
                  >
                    <el-option
                      v-for="countyItem in districtArr"
                      :key="countyItem.areaId"
                      :label="countyItem.areaName"
                      :value="countyItem.areaId"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              label="详细地址"
              prop="address"
              :label-width="formLabelWidth"
            >
              <el-input
                v-model="form.address"
                maxlength="300"
                placeholder="请填写详细地址"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="邮政编码"
              prop="postcode"
              :label-width="formLabelWidth"
              placeholder="请输入邮政编码"
            >
              <el-input
                v-model="form.postcode"
                maxlength="50"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="电子邮箱"
              prop="email"
              :label-width="formLabelWidth"
              placeholder="请输入电子邮箱"
            >
              <el-input
                v-model="form.email"
                maxlength="300"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label class="set-default">
              <el-checkbox v-model="form.isDefault">设为默认</el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :span="12"></el-col>
        </el-row>
      </el-form>
      <!-- <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false" class="btn-80-30-primary cancel-btn">
          取 消
        </el-button>
        <el-button
          class="btn-80-30-primary"
          v-preventReClick
          type="primary"
          @click="submitForm('addressForm')"
        >
          保 存
        </el-button>
      </div> -->
    </e-dialog>

    <prompt-modal
      :prompt-modal-visible="visible"
      :footer="true"
      @close="promptFinish"
    >
      <div slot="title" class="prompt-modal-title">
        <!-- <img src="@/static/common/warnIcon.png" alt /> -->
        <p>易派客提醒您：</p>
      </div>
      <div slot="content" class="prompt-modal-content">
        <h4>确定删除已选地址信息?</h4>
      </div>
      <div slot="footer">
        <el-button class="btn-80-30" type="primary" @click="promptFinish"
          >取消</el-button
        >
        <el-button
          v-prevent-re-click
          v-debounce="finish"
          class="btn-80-30-primary"
          type="primary"
        >
          确定
        </el-button>
      </div>
    </prompt-modal>
  </div>
</template>

<script>
import api from '@/modules/projectA/api/address/index';
import PromptModal from '@/modules/projectA/components/common/promptModal.vue';
import ETableList from '@/modules/projectA/components/common/e-table-list';
import EDialog from '@/modules/projectA/components/common/e-dialog';
import {
  mobile,
  email,
  postalCode,
} from '@/modules/projectA/utils/verification';

export default {
  components: {
    PromptModal,
    ETableList,
    EDialog,
  },
  data() {
    const checkedAddr = (rule, value, callback) => {
      console.log(this.form);
      if (this.form.provinceAreaId == '') {
        callback(new Error('请选择省份'));
      } else if (this.form.cityAreaId == '') {
        callback(new Error('请选择城市'));
      } else if (this.form.countryAreaId == '') {
        callback(new Error('请选择区/县/街道'));
      } else {
        callback();
      }
    };
    const addrAll = (rule, value, callback) => {
      if (!this.form.provinceAreaId) {
        callback(new Error('请选择省份'));
      } else if (!this.form.cityAreaId) {
        callback(new Error('请选择城市'));
      } else if (!this.form.countryAreaId) {
        callback(new Error('请选择区/县/街道'));
      } else {
        callback();
      }
    };
    return {
      fromMall: this.$route.query.from || '',
      loading: false, // 加载
      currentPage: 1, // 当前页
      pageSize: 10, // 每页条数
      activeName: 'first',
      tableData: [],
      tableLabel: [
        {
          label: '发货人',
          param: 'realName',
          align: 'center',
          width: '100',
        },
        {
          label: '发货地',
          param: 'shipAddress',
          align: 'center',
        },
        {
          label: '详细地址',
          param: 'address',
          align: 'center',
        },
        {
          label: '邮编',
          param: 'postcode',
          align: 'center',
          width: '100',
        },
        {
          label: '手机号',
          param: 'mobile',
          align: 'center',
          width: '110',
        },
        {
          label: '地址类型',
          param: 'addressType',
          align: 'center',
          width: '120',
        },
        {
          label: '是否默认',
          param: 'isDefault',
          align: 'center',
          width: '110',
          render(row) {
            return row.isDefault ? '是' : '否';
          },
        },
        {
          label: '操作',
          align: 'center',
          fixed: 'right',
          width: '180',
          slot: 'handle',
        },
      ],
      dialogType: 'add', // 弹窗类型：新增、编辑
      dialogFormVisible: false, // 新增弹窗
      formLabelWidth: '110px',
      userInfo: {}, // 用户数据
      visible: false, // 弹框提示
      deleteAddress: [],
      form: {
        checkedAddr: [],
        realName: '',
        mobile: '',
        address: '',
        provinceAreaId: '',
        cityAreaId: '',
        countryAreaId: '', // 区县
        addrAll: '',
        postcode: '',
        email: '',
        isDefault: false,
      },
      rules: {
        checkedAddr: [
          {
            type: 'array',
            required: true,
            message: '请至少选择一个地址类型',
            trigger: 'change',
          },
        ],
        realName: [
          {
            required: true,
            message: '请输入收件人姓名',
            trigger: ['blur', 'change'],
          },
        ],
        mobile: [
          {
            required: true,
            validator: mobile,
            trigger: ['blur', 'change'],
          },
        ],
        address: [
          {
            required: true,
            message: '请填写详细地址',
            // validator: checkedAddr,
            trigger: ['blur', 'change'],
          },
        ],
        addrAll: [
          {
            required: true,
            validator: addrAll,
            trigger: ['blur', 'change'],
          },
        ],
        postcode: [
          {
            required: true,
            validator: postalCode,
            trigger: ['blur', 'change'],
          },
        ],
        email: [
          {
            validator: (rule, value, callback) => {
              email(rule, value, callback, false, false);
            },
            // validator: email(),
            trigger: ['blur', 'change'],
          },
        ],
      },
      provinceArr: [], // 省份下拉选项
      cityArr: [], // 城市下拉选项
      districtArr: [], // 区县下拉选项
      tableSelection: [], // 已选中数据
      total: 0,
      size: 10,
      queryParams: {
        limit: 10,
        page: 1,
      },
    };
  },
  watch: {
    'form.provinceAreaId': {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal) {
          /* this.cityArr = [];
          this.districtArr = [];
          if (oldVal) {
            this.form.cityAreaId = '';
            this.form.countryAreaId = '';
          } */
          // this.cityArr = [];
          // this.districtArr = [];
          this.getCityByAreaId(newVal);
        }
      },
    },
    'form.cityAreaId': {
      immediate: true,
      handler(newVal, oldVal) {
        console.log(this.form, 'from');
        console.log(newVal, 'newVal');
        console.log(oldVal, 'oldVal');
        if (newVal) {
          /* this.districtArr = [];
          if (oldVal) {
            this.form.countryAreaId = '';
          } */
          // this.districtArr = [];
          this.getDistrictByCityId(newVal);
        }
      },
    },
    'form.countryAreaId': {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal) {
          setTimeout(() => {
            this.$refs.addressForm.validateField('addrAll');
          }, 0);
        }
      },
    },
  },
  mounted() {
    const aa = localStorage.getItem('userInfo');
    console.log(aa);
    this.userInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
    console.log(this.userInfo);
    this.getQueryPage();
  },
  methods: {
    // 省份改变
    provinceChange(val) {
      this.cityArr = [];
      this.districtArr = [];
      this.form.cityAreaId = '';
      this.form.countryAreaId = '';
      this.getCityByAreaId(val);
    },
    cityChange(val) {
      this.districtArr = [];
      this.form.countryAreaId = '';
      this.getDistrictByCityId(val);
    },
    // 切换条数
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.currentPage = 1;
      this.pageSize = val;
      this.getQueryPage();
    },
    // 当前页改变
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getQueryPage();
    },
    // 表格选中切换
    handleSelectionChange(val) {
      this.tableSelection = val;
      // this.tableSelection = [];
      // val.forEach((dt) => {
      // 	this.tableSelection.push(dt.addressId);
      // });
    },
    // 删除接口
    deleteOrderAddressApi(para) {
      this.visible = false;
      api.batchDelete({ addressId: para }).then((res) => {
        if (res.code === '200') {
          this.getQueryPage();
          this.$message({
            type: 'success',
            message: `删除成功`,
          });
        } else {
          this.$message({
            type: 'error',
            message: `删除失败`,
          });
        }
      });
    },
    // 点击删除
    deleteOrderAddress(dt) {
      this.deleteAddress = [
        // {
        dt.addressId, // 地址编号
        /* memberId: this.$store.state.USERINFO.memberId, //'100324', //会员编号
          addressType: dt.addressType, */
        // },
      ];
      this.visible = true;
    },
    // 批量删除
    delBatch() {
      /* let arr = [];
      this.tableSelection.forEach(dt => {
        let para = {
          addressId: dt.addressId,
          memberId: dt.memberId,
          addressType: dt.addressType,
        };
        arr.push(para);
      }); */

      const arr = this.tableSelection.map((item) => item.addressId);
      this.deleteAddress = arr;
      if (arr.length == 0) {
        this.$message({
          message: '请选择要删除的地址！',
          type: 'warning',
        });
        return;
      }
      this.visible = true;
    },
    // 关闭弹框
    promptFinish() {
      this.visible = false;
    },
    // 确定删除
    finish() {
      if (this.currentPage != 1 && this.tableData.length == 1) {
        this.currentPage -= 1;
      }
      this.deleteOrderAddressApi(this.deleteAddress);
    },
    // 提交   handleType = ''  handleType   新增：add   修改：''
    submitForm(formName) {
      // console.log(this.form.addressId == undefined ? 'add' : 'edit');
      const handleType = this.dialogType == 'add' ? 'add' : '';
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // let para = {
          // 	...this.form,
          // 	addressType: this.form.checkedAddr.toString(),
          // 	location: `${this.form.provinceAreaId},${this.form.cityAreaId},${this.form.countryAreaId}`,
          // 	option: handleType
          // };
          const para = {
            address: this.form.address, // 收件地址
            postcode: this.form.postcode, // 邮政编码
            mobile: this.form.mobile, // 手机号
            isDefault: this.form.isDefault ? 1 : 0, // 是否设置默认地址
            email: this.form.email, // 邮箱地址
            realName: this.form.realName, // 收件人
            addressType: this.form.checkedAddr.toString(), //	地址类型(1： 收票地址 2：收货地址)	是	[string]
            location: `${this.form.provinceAreaId},${this.form.cityAreaId},${this.form.countryAreaId}`, //	所在地区（取地区编号，用逗号分隔）
            option: handleType, // 操作标识
            addressId:
              this.form.addressId == undefined ? '' : this.form.addressId,
            companyId: this.$store.state.USERINFO.companyId,
            memberId: this.$store.state.USERINFO.memberId,
          };
          this.addInfoHandle(para);
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
    // 点击新增按钮
    handleAdd(formName) {
      // 清空 市县
      this.cityArr = [];
      this.districtArr = [];
      this.dialogType = 'add';
      this.resetForm('addressForm', 'clear');
      // this.getQueryAreaByCountryCode();
      // this.dialogFormVisible = true;
    },
    // 新增地址
    addInfoHandle(para) {
      const apiMethods = this.dialogType === 'add' ? 'addressAdd' : 'modify';
      api[apiMethods](para).then((res) => {
        if (res.code === '200') {
          this.resetForm('addressForm', 'clear');
          this.dialogFormVisible = false;
          this.getQueryPage();
          this.form = {
            checkedAddr: [],
            realName: '',
            mobile: '',
            address: '',
            provinceAreaId: '',
            cityAreaId: '',
            countryAreaId: '', // 区县
            addrAll: '',
            postcode: '',
            email: '',
            isDefault: false,
          };
          this.$message({
            type: 'success',
            message: '提交成功!',
          });
        } else {
          this.$message({
            type: 'info',
            message: res.message,
          });
        }
      });
    },
    resetFormData() {
      this.form = {
        checkedAddr: [],
        realName: '',
        mobile: '',
        address: '',
        provinceAreaId: '',
        cityAreaId: '',
        countryAreaId: '', // 区县
        addrAll: '',
        postcode: '',
        email: '',
        isDefault: false,
      };
    },
    // 重置新增
    resetForm(formName = 'addressForm', type = 'reset') {
      if (type == 'clear') {
        this.getQueryAreaByCountryCode();
        if (this.form.provinceAreaId !== '') {
          this.resetFormData();
          this.$refs[formName].resetFields();
        }
        this.dialogFormVisible = true;
      } else {
        this.$refs[formName].resetFields();
        this.getQueryAreaByCountryCode();
        this.dialogFormVisible = true;
      }
    },
    // 地址类型选择
    handleCheckedAddr() {
      console.log(this.form.checkedAddr);
    },
    // 修改
    rowEditHandle(dt) {
      console.log('编辑：', dt);
      this.dialogType = 'edit';
      this.form = {
        addressId: dt.addressId,
        checkedAddr: dt.addressType.toString().split(','),
        realName: dt.realName,
        mobile: dt.mobile,
        address: dt.address,
        provinceAreaId: Number(dt.provinceAreaId),
        cityAreaId: Number(dt.cityAreaId),
        countryAreaId: Number(dt.countryAreaId), // 区县
        addrAll: `${dt.provinceAreaId},${dt.cityAreaId},${dt.countryAreaId}`,
        postcode: dt.postcode,
        email: dt.email || '',
        isDefault: dt.isDefault,
        memberId: this.$store.state.USERINFO.memberId,
        companyId: this.$store.state.USERINFO.companyId,
      };
      console.log(this.form, 'this.form');
      this.getQueryAreaByCountryCode();
      this.dialogFormVisible = true;
    },
    // 获取地址列表
    getQueryPage() {
      this.loading = true;
      const para = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        /*  memberId: this.userInfo.memberId, //100324, //会员编号
        pageStart: (this.currentPage - 1) * this.pageSize, //起始页
        pageLimit: this.pageSize, //每页记录数 */
      };
      api.queryPage(para).then((res) => {
        this.loading = false;
        if (res.code === '200') {
          this.total = res.data.total;
          res.data.records.forEach((el) => {
            el.shipAddress = `${el.province}${el.city}${el.county}`;
          });
          this.tableData = res.data.records;
        }
        this.$emit('getMessage');
      });
    },
    // 获取省份信息
    getQueryAreaByCountryCode() {
      const para = {
        countryCode: 'CN',
      };
      api.queryAreaByCountryCode(para).then((res) => {
        if (res.code === '200') {
          this.provinceArr = res.data;
        }
      });
    },
    // 获取城市信息
    getCityByAreaId(provinceAreaId) {
      const para = {
        parentAreaId: provinceAreaId,
      };
      api.getCityByAreaId(para).then((res) => {
        if (res.code === '200') {
          this.cityArr = res.data;
        }
      });
    },
    // 获取区县信息
    getDistrictByCityId(cityAreaId) {
      const para = {
        parentAreaId: cityAreaId,
      };
      api.getDistrictByCityId(para).then((res) => {
        if (res.code === '200') {
          this.districtArr = res.data;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.table-out {
  margin-top: 20px;
}
</style>
